import React from 'react'
import Select from 'react-select'

function docToOption(doc) {
  return {
    label: doc.label,
    value: doc,
    doc: doc,
  }
}

export default
class SelectField extends React.Component {

  mapValue() {
    const { options, field } = this.props;

    const value = field.value && field.value._id
      ? docToOption(field.value)
      : options 
        ? options.find(option => {
          if(typeof option.value === 'object') {
            return JSON.stringify(option.value) === JSON.stringify(field.value)
          }
          return option.value == field.value;
        })
        : ''; 

    return value ? value : null;
  }

  render() {
    const { options, field, form, ...props } = this.props;
    return(
      <Select
        {...props}
        className="Select"
        options={options}
        selectProps={{ id: field.name }}
        name={field.name}
        value={this.mapValue()}
        onChange={(option) => form.setFieldValue(field.name, option.value)}
        onBlur={field.onBlur}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/form/components/input/Select.jsx